export const SCOPE = {
  VISITOR_TYPE: 'visitorType',
  DEVICE_TYPE: 'deviceType',
  SITE: 'site',
};

export const SCOPES = Object.values(SCOPE);
